import React from 'react';
import { Modal, Button, Form, Row, Col } from 'antd';
import { SelectBiaya, SelectTahunAjaran } from '../../../../components/select';

class Filter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,
        };
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    render() {

        return (
            <Modal
                title="Filter"
                width={300}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Tutup</Button>
                    <Button type='primary' onClick={this.props.setTableFilterFromTemp}>Terapkan</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={24}>
                            <Form.Item label="Tahun Ajaran">
                                <SelectTahunAjaran
                                    onChange={(val) => {
                                        this.handleChangeSetValue("detail_pemasukan_id", null)
                                        this.props.setTempTableFilter("detail_pemasukan_id", null)
                                        
                                        this.handleChangeSetValue("tahun_ajaran", val ? val : null)
                                        this.props.setTempTableFilter("tahun_ajaran", val ? val : null)

                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Biaya">
                                <SelectBiaya
                                    thnAjaran={this.state.values.tahun_ajaran ? this.state.values.tahun_ajaran : ""}
                                    value={this.state.values.detail_pemasukan_id ? this.state.values.detail_pemasukan_id : null}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("detail_pemasukan_id", val ? val : null)
                                        this.props.setTempTableFilter("detail_pemasukan_id", val ? val : null)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form >
            </Modal >
        )
    }
}

export default Filter;
